import { render, staticRenderFns } from "./HubContactsGroups.vue?vue&type=template&id=40ff1f84&"
import script from "./HubContactsGroups.vue?vue&type=script&lang=js&"
export * from "./HubContactsGroups.vue?vue&type=script&lang=js&"
import style0 from "./HubContactsGroups.vue?vue&type=style&index=0&id=40ff1f84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports